export default {
    INSURANCE_DETAIL_BEGIN: 'INSURANCE_DETAIL_BEGIN',
    INSURANCE_DETAIL_SUCCESS: 'INSURANCE_DETAIL_SUCCESS',
    INSURANCE_DETAIL_ERROR: 'INSURANCE_DETAIL_ERROR',
    INSURANCE_DETAIL_CLEANUP: 'INSURANCE_DETAIL_CLEANUP'
};